export class QueryCommentModel
{
    QueryCode : number = 0;
    QueryDetailCode : number = 0;
    Comment : string = '';
    CommentAddedBy : number = 0;
}